import { render, staticRenderFns } from "./BatteryChargePercent.vue?vue&type=template&id=188ff2d6&"
import script from "./BatteryChargePercent.vue?vue&type=script&lang=js&"
export * from "./BatteryChargePercent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188ff2d6')) {
      api.createRecord('188ff2d6', component.options)
    } else {
      api.reload('188ff2d6', component.options)
    }
    module.hot.accept("./BatteryChargePercent.vue?vue&type=template&id=188ff2d6&", function () {
      api.rerender('188ff2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/shared/components/BatteryChargePercent.vue"
export default component.exports